import React, { useEffect, useState, useContext } from "react";

import Fade from "@material-ui/core/Fade";
import { Spinner } from "../../StyledComponent";
import { getNoticias } from "../../../services/meuImovel";
import DirecionalLogo from "../../../assets/Direcional_RGB_branco.png";
import RivaLogo from "../../../assets/logos/Grupo 291@2x.png";
import Slider from "react-slick";
import { ReactComponent as Unread } from "../../../assets/novosicones/MeuImovel/mark_email_unread_black_24dp.svg";
import { Button } from "../buttonStyled";
import { ContextoListaApartamentos } from "../../ApartamentList/contextoImoveis";
import NotFoundError from "../NotFoundError";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./styles.scss";

const Noticias = ({
  idEmpreendimentoImovelSelecionado,
  tipoEmpreendimento,
  // noticiaId,
}) => {
  const [noticias, setNoticias] = useState([]);
  const [loading, setLoading] = useState(false);

  const { tema } = useContext(ContextoListaApartamentos);

  useEffect(() => {
    if (idEmpreendimentoImovelSelecionado) loadNoticias();
  }, [idEmpreendimentoImovelSelecionado]);

  async function loadNoticias() {
    setLoading(true);

    let resultNoticias = await getNoticias(idEmpreendimentoImovelSelecionado);

    if (resultNoticias?.length > 0) {
      // if (noticiaId && !verificaSeNoticiaExiste(resultNoticias))
      //   handleNotificationError();
      // else
      setNoticias(
        resultNoticias.sort(
          (a, b) =>
            new Date(b.LastModifiedDate).getTime() -
            new Date(a.LastModifiedDate).getTime()
        )
      );
    } else {
      setNoticias([]);
    }
    setLoading(false);
  }

  // function verificaSeNoticiaExiste(resultNoticias) {
  //   let noticiaExiste = resultNoticias.filter(
  //     (noticia) => noticia.Id === noticiaId
  //   );

  //   if (noticiaExiste.length > 0) return true;
  // }

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  if (loading) return <Spinner />;

  function changeDataLastModified(data) {
    let dataSplit = data.split("-");
    return (
      dataSplit[2] + " de " + setMonth(dataSplit[1]) + " de " + dataSplit[0]
    );
  }

  function setMonth(month) {
    var months = [
      { mesNumero: 1, extenso: "Janeiro" },
      { mesNumero: 2, extenso: "Fevereiro" },
      { mesNumero: 3, extenso: "Março" },
      { mesNumero: 4, extenso: "Abril" },
      { mesNumero: 5, extenso: "Maio" },
      { mesNumero: 6, extenso: "Junho" },
      { mesNumero: 7, extenso: "Julho" },
      { mesNumero: 8, extenso: "Agosto" },
      { mesNumero: 9, extenso: "Setembro" },
      { mesNumero: 10, extenso: "Outubro" },
      { mesNumero: 11, extenso: "Novembro" },
      { mesNumero: 12, extenso: "Dezembro" },
    ];

    let m = months.filter((mes) => {
      return mes.mesNumero == month;
    });
    return m[0].extenso;
  }

  return (
    <Fade in>
      <div className="meuImovelNoticias">
        <h1
          style={{ color: tema.primaryColor, justifyContent: "flex-start" }}
          className="centralized"
        >
          <Unread style={{ fill: tema.primaryColor, marginRight: "15px" }} />{" "}
          Notícias
        </h1>
        {noticias.length == 0 && (
          <NotFoundError text={"Nenhuma notícia encontrada."} />
        )}
        {noticias.length > 0 && (
          <Slider {...settings}>
            {noticias.map((noticia) => (
              <div key={noticia.Id} className="meuImovelNoticias__noticia">
                <div
                  className="meuImovelNoticias__noticia__data centralized"
                  style={{ border: `2px solid ${tema.primaryColor}` }}
                >
                  <div
                    className="meuImovelNoticias__noticia__data__logo centralized"
                    style={{ backgroundColor: tema.primaryColor }}
                  >
                    {tipoEmpreendimento == "DIRECIONAL ENGENHARIA S.A." ? (
                      <Fade>
                        <>
                          <img src={DirecionalLogo} alt="Logo Direcional" />{" "}
                        </>
                      </Fade>
                    ) : (
                      <Fade>
                        <>
                          <img src={RivaLogo} alt="Logo Riva" />
                        </>
                      </Fade>
                    )}
                  </div>
                  <div className="meuImovelNoticias__noticia__data__data centralized">
                    <p id="noticiasDate">
                      <span>Belo Horizonte, </span>
                      {changeDataLastModified(
                        noticia.LastModifiedDate.split("T")[0]
                      )}
                    </p>
                  </div>
                </div>

                <div className="meuImovelNoticias__noticia__corpo">
                  <span>Título</span>
                  <h2>{noticia.Titulo}</h2>
                  {noticia.ResumoNoticia && (
                    <>
                      <span>Corpo</span>
                      <p>{noticia.ResumoNoticia}</p>
                    </>
                  )}
                </div>

                <a
                  href={noticia.RedirecionamentoImagem}
                  target="_blank"
                  rel="noreferrer"
                >
                  <Button
                    bg={tema.primaryColor}
                    className="meuImovelNoticias__vejaMais"
                    disabled={noticia.RedirecionamentoImagem == null && true}
                  >
                    CLIQUE AQUI E SAIBA MAIS
                  </Button>
                </a>
              </div>
            ))}
          </Slider>
        )}
      </div>
    </Fade>
  );
};

export default Noticias;
